import React from "react";

const WeCheckSection = ({children, minHeight, className}) => (
	<section className = {`section center ${className}`} style = {{minHeight}} >
		{children}
	</section >
);

export {WeCheckSection};
